import type { AgingRow } from '../api';

export type BucketTotals = Omit<AgingRow, 'name'>;

const ZERO_TOTALS: BucketTotals = {
  current: 0,
  days1to30: 0,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0,
  total: 0,
};

/**
 * Reduce-sum all six bucket fields across the given rows.
 * When rows is empty, returns all-zeros.
 * When unfiltered (rows === data.rows), the result equals the QB grand total
 * — but we always compute from rows so filtered views show their own subtotals.
 */
export function computeFilteredTotals(rows: AgingRow[]): BucketTotals {
  return rows.reduce<BucketTotals>(
    (acc, row) => ({
      current: acc.current + row.current,
      days1to30: acc.days1to30 + row.days1to30,
      days31to60: acc.days31to60 + row.days31to60,
      days61to90: acc.days61to90 + row.days61to90,
      days91plus: acc.days91plus + row.days91plus,
      total: acc.total + row.total,
    }),
    { ...ZERO_TOTALS },
  );
}
